import {
    createKeys,
    usePostLoginAdminHttp,
    usePostLoginHttpWithErrors
} from "mfe-lib-bfo-shared/query";

export const applicationKeys = createKeys("applications");

export const useFormSessionRefresh = (tokenName: string, refreshUrl: string) => {
    // const qc = useQueryClient()

    const { api } = tokenName === "user" ? usePostLoginHttpWithErrors() : usePostLoginAdminHttp();

    return api.useApiMutation<any, any>(
        (data) => ({
            method: "POST",
            path: refreshUrl,
            context: {
                skipSessionAuth: true,
            },
            body: {
                offset: data?.adjustedValidity,
                refreshToken:
                    tokenName === "user"
                        ? sessionStorage.getItem("user.refreshToken")
                        : sessionStorage.getItem("admin.refreshToken"),
            },
        }),
        {
            mutationKey: ["creditApplication", "session"],
        },
    );
};
